
import BaseTable, { ColumnType } from "../../../components/elements/BaseTable"
import { ReportWithRelationsType } from "../types"
import { useDeleteReportMutation, useToggleReportArchiveMutation } from "../api/services"
import { useQueryClient } from "@tanstack/react-query"
import { GeneralQueryKeys } from "../../../api/constants"
import ReportTableRow from "./ReportTableRow"

type ReportsTableProps = {
    reports: ReportWithRelationsType[]
    searchTerm: string
}

export default function ReportsTable({ reports, searchTerm }: ReportsTableProps) {
    const queryClient = useQueryClient()

    // Mutations
    const { mutate: deleteReport } = useDeleteReportMutation(queryClient, GeneralQueryKeys.REPORT + searchTerm)
    const { mutate: toggleArchive } = useToggleReportArchiveMutation(queryClient, GeneralQueryKeys.REPORT + searchTerm)

    const handleDeleteReport = (id: string) => {
        if (window.confirm("Möchten Sie diesen Bericht wirklich löschen?")) {
            deleteReport(id)
        }
    }

    const handleToggleArchive = (id: string) => {
        toggleArchive(id)
    }

    const reportTableColumns: ColumnType[] = [
        {
            label: "Datum",
        },
        {
            label: "Objekt",
        },
        {
            label: "Information",
            responsive: "hidden lg:table-cell",
        },
        {
            label: "Dokumente",
            responsive: "hidden md:table-cell",
        },
        {
            label: "Materialien",
            responsive: "hidden md:table-cell",
        },
        {
            label: "Erstellt",
            responsive: "hidden lg:table-cell",
        }
    ]

    return (
        <BaseTable
            columns={reportTableColumns}
            tbody={reports.map((report) => (
                <ReportTableRow
                    key={report._id}
                    report={report}
                    onDelete={handleDeleteReport}
                    onToggleArchive={handleToggleArchive}
                />
            ))}
        />
    )
}
